<!--<wm-data-entity-view-list [entities]="entities"></wm-data-entity-view-list>-->
<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [isReadOnly]="true"
></wm-form-activity-input-view>
